import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { RegistroForm } from '@app/components/auth/RegistroForm/RegistroForm';

const RegistroPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Registro')}</PageTitle>
      <RegistroForm />
    </>
  );
};

export default RegistroPage;
